const leadershipModals = (gsap, smoother, ScrollTrigger) => {
  
  var keys = {37: 1, 38: 1, 39: 1, 40: 1};

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
      get: function () { supportsPassive = true; } 
    }));
  } catch(e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

  // call this to Disable
  function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  // call this to Enable
  function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  }
  
  function noBodyScroll() {
    smoother.paused(true);
    $('html, body').addClass('superlock');
    ScrollTrigger.refresh();
  }

  function yesBodyScroll() {
    smoother.paused(false);
    $('html, body').removeClass('superlock');
    ScrollTrigger.refresh();
  }

  function toggleClassGrow() {
  const $imgFake = $('.modal-content .img-fake');
	if ($imgFake.hasClass('grow')) {
		$imgFake.removeClass('grow');
		$('.modal-content .leader-image, .modal-content .img-fake, .modal-content .leader-bio').empty();
	} else {
		$imgFake.addClass('grow');
	}
  }


  // j's butcherings & spaghetti
  const $leaderLink = $('.leader-link');
  const leaderLinkCount = $leaderLink.length;
  let lastClicked = 0;

  $leaderLink.on('click', function(e) {
	e.preventDefault();

	//variables
	const index = $leaderLink.index(this) + 1;
	const biggest = Math.max(window.innerWidth, window.innerHeight);
	const scale = Math.ceil(biggest / 100 * 2);

	const $imgFake = $('.modal-content .img-fake');
	const $bgFake = $('.modal-content .bg-fake');
	const $title = $(this).find('.sub-text-sm').text();
	const $rawName = $(this).find('.h5').text();
	const $name = $rawName.replace(/(\S+)/, '$1'+'<br>');
	const $bio = $(this).find('.hidden-bio').children();

	const $pageImg = $(this).find('.img>img');
	const pageRect = $pageImg[0].getBoundingClientRect();

	if ($('.leadership-modal').is(':visible') === true) {

		//transition out
		gsap.timeline()
			.to('.leader-image img, .img-fake, .h2, .leader-bio', {duration: 0.5, autoAlpha: 0, onComplete: updateModal})

		function updateModal() {
			const $newImg = $leaderLink.eq(index - 1).find('.img>img');

			// DOM manipulation
			$('.modal-content .leader-image, .modal-content .img-fake, .modal-content .leader-bio').empty();
			// $newImg.clone().appendTo('.modal-content .img-fake');
			$newImg.clone().appendTo('.modal-content .leader-image');
			$bio.clone().appendTo('.modal-content .leader-bio');
			$('.modal-content .h2').html('<span class="inline-eyebrow">' + $title + '</span> ' + $name);
			$('.modal-content .current').text(index);


			//animation
			// const $newFake = $('.modal-content .img-fake');
			// const $modalImg = $('.leader-image img');
			setTimeout(() => { //necessary hack for getboundingclientrect to not return 0 values
				// const modalRect = $modalImg[0].getBoundingClientRect();
				gsap.timeline()
					// .set($newFake, {width: modalRect.width, x: modalRect.x, y: modalRect.y})
					// .to('.img-fake, .h2, .leader-bio', {duration: 0.5, autoAlpha: 1, onComplete: updateUrl})
					.to('.leader-image img, .h2, .leader-bio', {duration: 0.5, autoAlpha: 1, onComplete: updateUrl})
			}, 50);

		}

	} else {

		lastClicked = index - 1;
		gsap.set('.leadership-modal', {autoAlpha: 1, display: "block"});

		//DOM manipulation
		$pageImg.clone().appendTo($imgFake);
		$pageImg.clone().appendTo('.modal-content .leader-image');
		$bio.clone().appendTo('.modal-content .leader-bio');
		$('.modal-content .h2').html('<span class="inline-eyebrow">' + $title + '</span> ' + $name);
		$('.modal-content .current').text(index);
		$('.modal-content .total').text(leaderLinkCount);

		const $modalImg = $('.leader-image img');

		//animation
		gsap.timeline()
			.set($imgFake, {autoAlpha: 1, width: pageRect.width, x: pageRect.x, y: pageRect.y})
			.set($bgFake, {x: pageRect.x + (pageRect.width / 2 - 50), y: pageRect.y + (pageRect.height / 2 - 50), ease: "expo.out"})
			.to($bgFake, {duration: 1, scale: scale})
			.set({}, {onComplete: noBodyScroll}, "-=0.33")
			.to('.single-leader', {duration: 0.3, autoAlpha: 1, onComplete: updateUrl})
			.set($bgFake, {autoAlpha: 0, display: "none"});

		setTimeout(() => { //necessary hack for getboundingclientrect to not return 0 values
		const modalRect = $modalImg[0].getBoundingClientRect();
		gsap.timeline()
			.to($imgFake, {duration: 2, width: modalRect.width, x: modalRect.x, y: modalRect.y, ease: "expo.inOut"})
			.to('.h2', {duration: 1, autoAlpha: 1}, "-=0.75")
			.to('.arrow-left, .team-pagination p, .arrow-right, .leader-close', {duration: 1, autoAlpha: 1}, "-=0.75")
			.to('.leader-bio', {duration: 1, autoAlpha: 1}, "-=0.75");

		toggleClassGrow();
		}, 150);
	}

	function updateUrl() {
		const url = '/team/' + $rawName.replace(/\s+/g, '-').toLowerCase();
		window.history.pushState({}, $rawName, url);
		document.title = $rawName;
	}

  });

  $('.leader-close').on('click', function(e) {
	e.preventDefault();

	const $imgFake = $('.modal-content .img-fake');
	const $bgFake = $('.modal-content .bg-fake');
	const $bgActual = $('.modal-content .bg-actual');

	gsap.timeline()
		.set($bgActual, {autoAlpha: 0})
		.set($bgFake, {autoAlpha: 1, display: "block"})
		.to('.single-leader', {duration: 0.4, autoAlpha: 0})
		.to($imgFake, {duration: 0.3, autoAlpha: 0}, "-=0.4")
		.to($bgFake, {duration: 0.5, scale: 0, onComplete: updateUrl})
		.set('.h2, .arrow-left, .team-pagination p, .arrow-right, .leader-close, .leader-bio', {autoAlpha: 0, onComplete: yesBodyScroll})
		.set('.leadership-modal', {autoAlpha: 0, display: "none", onComplete: toggleClassGrow});

	function updateUrl() {
		window.history.pushState({}, 'About', '/about');
		document.title = 'About Us';
	}
  });

  $('.arrow-left').on('click', function(e) {
	e.preventDefault();
	lastClicked--;
	if (lastClicked < 0) lastClicked = leaderLinkCount - 1;
	$leaderLink.eq(lastClicked).trigger('click');
  }); 

  $('.arrow-right').on('click', function(e) {
	e.preventDefault();
	lastClicked++;
	if (lastClicked > (leaderLinkCount - 1)) lastClicked = 0;
	$leaderLink.eq(lastClicked).trigger('click');
  });

  function resizeLeaderImage() {
    if ($('.leadership-modal').is(':visible') === true) {
      const $imgFake = $('.modal-content .img-fake');
      const $modalImg = $('.leader-image img');
      const modalRect = $modalImg[0].getBoundingClientRect();
      gsap.set($imgFake, {width: modalRect.width, x: modalRect.x, y: modalRect.y, ease: "none"});
    }
  }

  window.onresize = resizeLeaderImage;

  window.onpopstate = function() {
    $('.leader-close').trigger('click');
  }
  
}

export {
  leadershipModals
}